import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {DataTableLocalization, Translate} from "../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import MaterialTable from "material-table";
import {tableIcons} from "../../../../config/design/TableIcons";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import moment from "jalali-moment";
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import {TableCount, TablePage} from "../../../../config/Permissions";
import Container from "@material-ui/core/Container/Container";
import SubTitle from "../../../components/elements/SubTitle";
import Button from "@material-ui/core/Button/Button";
import AppCardLoaderTable from "../../../components/Skeletons/AppCardLoaderTable";
import AppCard from "../../../components/layouts/components/AppCard";
import AppAnimate from "../../../components/AppAnimate";
import Typography from "@material-ui/core/Typography/Typography";

class ManageContact extends React.Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    state = {
        columns: [
            { title: Translate.userName, field: 'name'},
            { title: Translate.mobile, field: 'mobile'},
            { title: Translate.product, field: 'product'},
            {
                title: Translate.created_at,
                editable: 'never',
                field: 'created_at',
                render: rowData =>
                    <Typography className="date_in_table">
                        {`${moment(rowData.created_at).locale('fa').fromNow()}`}
                        <br/>
                        {`${moment(rowData.created_at).locale('fa').format( 'HH:mm , YYYY/M/D')}`}
                    </Typography>
            },
        ],
        data: [],
        loading:false,
        ChangeLoader:false
    };
    componentDidMount(){
        this.loadData();
    }
    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()

    }
    onDelete(id,hasNotif = true) {
        let data = new FormData();
        data.append('id', id);
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/pages/violation/delete`, data, config)
            .then(response => {
                if(hasNotif){
                    this.props.enqueueSnackbar(Translate.deleteData, {
                        variant: 'success',
                    });
                }
                return true
            })
            .catch(error => {
                this.props.enqueueSnackbar(Translate.deleteDataFailed, {
                    variant: 'error',
                });
                return false
            });
    }
    render(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        return (
                <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.manageViolations}>
                    <Grid container spacing={2} justify="center">
                        <Grid item xs={12}>
                            <AppCard
                                title={ Translate.manageViolations}
                                action={
                                    <BreadCrumbs singleLevel firstText={Translate.manageViolations}/>
                                }>
                                {
                                    this.state.loading ? <AppCardLoaderTable/> :
                                        <Container maxWidth="xl">
                                            <MaterialTable
                                                tableRef={this.tableRef}
                                                icons={tableIcons}
                                                onRowClick={(event, rowData, togglePanel) => togglePanel()}
                                                title={" "}
                                                localization={DataTableLocalization}
                                                columns={this.state.columns}
                                                data={query =>
                                                    new Promise((resolve, reject) => {
                                                        axios.get(`${defaultVariabls.url}/pages/violations/quickView?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}`, config)
                                                            .then(response => {
                                                                let data = [];
                                                                // eslint-disable-next-line
                                                                response.data.data.map((row) => {
                                                                    data.push({
                                                                        name: row.user.first_name+" "+row.user.last_name,
                                                                        id: row.id,
                                                                        message: row.message,
                                                                        email: row.user.email,
                                                                        mobile: row.user.mobile,
                                                                        product: row.product.name,
                                                                        slug: row.product.slug,
                                                                        created_at: row.created_at,
                                                                    })
                                                                });
                                                                resolve({
                                                                    data: data,
                                                                    page: response.data.current_page - 1,
                                                                    totalCount: response.data.total,
                                                                })
                                                            }).catch(error => {
                                                            console.log(error.response)
                                                        })
                                                    })
                                                }
                                                options={{
                                                    pageSize: TablePage,
                                                    pageSizeOptions: TableCount,
                                                }}
                                                detailPanel={rowData => {
                                                    return (
                                                        <Grid container spacing={2}   direction="row" justify="center">
                                                            <Grid item xs={12} md={6}>
                                                                <SubTitle align="left">{Translate.report}</SubTitle>
                                                                <p>{rowData.message}</p>
                                                            </Grid>
                                                            <Grid item xs={12} md={3}>
                                                                <SubTitle align="left">{Translate.email}</SubTitle>
                                                                <p dir={"ltr"}>{rowData.email}</p>
                                                            </Grid>
                                                            <Grid item xs={12} md={3}>
                                                                <SubTitle align="left">{Translate.mobile}</SubTitle>
                                                                <p dir={"ltr"}>{rowData.mobile}</p>
                                                            </Grid>
                                                        </Grid>
                                                    )
                                                }}
                                                editable={{
                                                    onRowDelete: oldData =>
                                                        new Promise(resolve => {
                                                            setTimeout(() => {
                                                                resolve();
                                                                this.onDelete(oldData.id);
                                                                this.setState(prevState => {
                                                                    const data = [...prevState.data];
                                                                    data.splice(data.indexOf(oldData), 1);
                                                                    return { ...prevState, data };
                                                                });
                                                            }, 600);
                                                        }),
                                                }}

                                            />
                                        </Container>
                                }
                            </AppCard>
                        </Grid>
                    </Grid>
                </AppAnimate>
        );
    }
}


export default withSnackbar(withRouter(withStyles(Styles)(ManageContact)));